import { Sprite } from 'pixi.js'
import { Device } from 'utils/Device'
import { trim } from 'utils/Trim'

import Graphics from './Graphics'

export default class Image extends PIXI.Container{
  constructor(data) {
    super()
    this._data = data
    this.createImage()
  }

  get data(){
    return this._data
  }

  getTextureName(path){
    return trim.removeImageExtension(path.split('/').pop())
  }

  createImage(){
    const data = this.data
    const images = data.images.map((path, idx) => {
      const texture = game.getTextureFromAtlases(this.getTextureName(path))
      const image = new Sprite(texture)
      image.visible = !idx
      if (data.alpha) {
        image.alpha = data.alpha
      }
      if (data.angle == 90) {
        image.angle = 90
        image.x += image.height
      }
      this.addChild(image)
      return image
    })

    this.scale.set(data.scale)
    this.images = images

    //todo --------------------------------------
    if (data.hitzone) {
      const rectangle = new Graphics({
        alpha: 0,
        width: this.width * data.hitzone,
        height: this.height * data.hitzone,
      })

      if(Device.isDesktop()){
        rectangle.x = (this.width - rectangle.width) / 2
        rectangle.y = (this.height - rectangle.height) / 2
      }
      else {
        rectangle.x = (this.width - rectangle.width / 2)
        rectangle.y = (this.height - rectangle.height / 2)
      }

      this.addChild(rectangle)
    }
  }

  calculateGlow(){
    if(this.images.length > 1){
      const xOffest = Math.abs(this.images[0].width - this.images[1].width )
      const yOffest = Math.abs(this.images[0].height - this.images[1].height )

      this.images.forEach((image, index) => {
        image.anchor.set(0.5)
        image.x = image.width / 2
        image.y = image.height / 2
        if(index > 0){
          image.x =  image.x - xOffest / 2
          image.y = image.y - yOffest / 2
        }

      })
    }

  }
}
